import { Component, OnInit, ViewChild } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Base64Pipe } from '../../../services/pipes/base64/base64.pipe';
import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-new-orders',
  templateUrl: './new-orders.component.html',
  styleUrls: ['./new-orders.component.css']
})
export class NewOrdersComponent implements OnInit {

    // public orderStatus        : any = AppSettings.orderStatus;
    public writersRegion      : any = AppSettings.writersRegion;
    public loading            : any = false;
    public paginatePage       : any;
    public leads              : any = [];
    public leads_Copy         : any = [];
    public comments           : any = [];
    public agentComments      : any = [];
    public qaComments         : any = [];

    public posIndex           : any;
    public posVal             : any;
    public status          : any = [
                                        { name:'New Orders', value: -1 },
                                        { name:'Awaiting Feedback',   value: 1 },
                                        { name:'Refund',      value: 7 }
                                      ];
    public orderStatus          : any = [
                                      { name:'New Orders', value: -1 },
                                      { name:'Awaiting Feedback',   value: 1 }
                                    ];
    public positions          : any = [
                                        { name:'All Positions', value: 'all' },
                                        { name:'No Position',   value: '0' },
                                        { name:'On Query',      value: '1' },
                                        { name:'On Hold',       value: '2' }
                                      ];
    public twoCoOrderPfStatus          : any = [
                                        { name:'Pass',   value: 'pass' },
                                        { name:'Fail',      value: 'fail' },
                                        { name:'Wait',       value: 'wait' }
                                      ];

    public positionStatus          : any = [
                                        // { name:'New Order',     value: 0 },
                                        { name:'No Position',   value: 0 },
                                        { name:'On Query',      value: 1 },
                                        { name:'On Hold',       value: 2 }
                                      ];

    public verifyOrNot        : any = [
                                        { name: 'Verified / Unverified', value: '' },
                                        { name: 'Verified',              value: '1' },
                                        { name: 'Unverified',            value: '2' }
                                      ];
    public agentsSub          : any;
    public agents             : any;
    public qa                 : any;
    public loader             : any;

    @ViewChild(DataTableDirective)
    public dtElement    : DataTableDirective;
    public dtOptions    : DataTables.Settings = {};
    public dtTrigger    : any = new Subject();

    public searchParams  : any =  { order_Id_Email_Phone : '', position:'all', status: -1, two_co_order_pf_status: null, agent_id: null, date_from: '', date_to:'', order_verified_by:'' };
    public fullRangeDate : any;
    public selectedDesposition     : any;
    public writers                 : any;
    public all_users               : any;
    public lead_id_Verify          : any;
    public lead_Verify_index       : any;
    public lead_status             : any;
    public notes                   : any;
    public addingNote              : any = false;
    public addNoteId               : any;
    public addNoteIndex            : any;
    public sendingEmail            : any = false;
    public base64Pipe              : any = new Base64Pipe;

    constructor(
      private helperService        : HelperService,
      private agentsService        : Agents,
    ) {

        // Add Select Region Option
        this.writersRegion.splice(0, 0, "");

        // Get Agents
        this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
          if (agents) {
            this.agents     = agents.agents;
            this.qa         = agents.qa;
            this.writers    = agents.writers;
            this.all_users  = agents.all_users;
          }
        });

        this.dtOptions = {
          paging: true,
          info: true,
          // ordering: false,
          pagingType: 'full_numbers',
          pageLength: 10,
          serverSide: true,
          processing: true,
          searching: false,
          'language': AppSettings.dataTableLang,
          "columnDefs": [
            { "orderable": false,                           "targets": 0 },
            { "orderable": false,                           "targets": 1 },
            { "orderable": false,                           "targets": 2 },
            { "orderable": false,                           "targets": 3 },
            { "orderable": false,                           "targets": 4 },
            { "orderable": true,                            "targets": 5 },
            { "orderable": false,                           "targets": 6 },
            { "orderable": false,                           "targets": 7 },
            { "orderable": false,                           "targets": 8 },
            { "orderable": false,                           "targets": 9 },
            { "orderable": false,                           "targets": 10 },
            { "orderable": false,                           "targets": 11 },
            { "orderable": false,                           "targets": 12 },
          ],
          "order": [[ 5, "asc" ]],
          ajax: (dataTablesParameters: any, callback) => {
            // Show Loader
            this.loading = true;
            // console.log("dataTablesParameters", dataTablesParameters);

            let url  = AppSettings.API_ENDPOINT + 'support/new-orders';

            let dtParams = {
                            order_Id_Email_Phone : this.searchParams.order_Id_Email_Phone,
                            date_from            : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
                            date_to              : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false)   : '',
                            order_verified_by    : this.searchParams.order_verified_by,
                            position             : this.searchParams.position,
                            status               : this.searchParams.status,
                            two_co_order_pf_status: this.searchParams.two_co_order_pf_status,
                            start                : dataTablesParameters.start,
                            length               : dataTablesParameters.length,
                            order                : dataTablesParameters.order,
                            columns              : dataTablesParameters.columns
                          };

            // For Record Serial Numbers
            this.paginatePage = dataTablesParameters.start;
            this.leads.data = [];
            this.helperService.httpPostRequestsDecryp(url, dtParams)
              .then( resp => {
                  this.leads        = JSON.parse(resp);
                  this.leads_Copy   = $.extend(true, {}, this.leads);

                  console.log("this.leads", this.leads);

                  // Set Default page len
                  this.dtOptions.pageLength = this.dtElement['dt'].page.len();

                  // Hide Loader
                  this.loading = false;

                  callback({
                    recordsTotal: this.leads.total,
                    recordsFiltered: this.leads.total,
                    // recordsFiltered: resp['recordsFiltered'],
                    // recordsFiltered: 1000,
                    data: []
                  });

                  // // $(".paginate_button .current").css("color", "white");
                  // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
                  $('div.dataTables_length select').addClass('dt-form-control');
                  $('div.dataTables_filter input').addClass('dt-form-control');
              })
              .catch(error => {
                  // Set loader false
                  this.loading = false;

                  // // Rerender DT in case of failure
                  // this.rerender();

                  console.log("error: ",error);
              });
          },
          columns: [
            // { data: 'multiDelete' },
            { data: 'id' },
            { data: 'order_id' },
            { data: 'timestamp' },
            { data: 'client_info' },
            { data: 'price_noOfPages' },
            { data: 'delivery_date' },
            { data: 'academic_level' },
            { data: 'assigned' },
            { data: 'writerDD' },
            { data: 'orderStatus' },
            { data: 'verification' },
            { data: 'notes' },
            { data: 'action' }
          ],
          // Use this attribute to enable the responsive extension
          responsive: false
        }

    }

    ngOnInit() {}

    ngAfterViewInit(){
      this.dtTrigger.next();
    }

    ngOnDestroy(): void {
      // Do not forget to unsubscribe the event
      this.dtTrigger.unsubscribe();

      if (typeof this.agentsSub != 'undefined') {
        //prevent memory leak when component destroyed
        this.agentsSub.unsubscribe();
        }
    }

    rerender(): void {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

        // Destroy the table first
        dtInstance.destroy();

        // Call the dtTrigger to rerender again
        this.dtTrigger.next();
      });
    }

    splitFromTo(){
      if(this.fullRangeDate){
        this.searchParams.date_from = this.fullRangeDate[0];
        this.searchParams.date_to =   this.fullRangeDate[1];
      }
      this.rerender();
    }

    sendEmailsToWriters() {
      // Hide modal
      $("#sendEmailModal").modal("hide");

      // Show loader
      this.sendingEmail = true;

      let url = AppSettings.API_ENDPOINT + "support/send-emails-to-writers";
      let data = {};

      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined" && resp.status == "OK") {
            Swal.fire('', resp.message , 'success');
          }
          if(typeof resp != "undefined" && resp.status == "ERROR") {
            Swal.fire('', resp.message , 'error');
          }

          // Hide loader
          this.sendingEmail = false;
      }).catch(err => {
          // Hide loader
          this.sendingEmail = false;
      });
    }

    updateWriter(lead, index) {
      if(!lead.writerDD_Col.writerDD) {
        this.leads.data[index].writer_id = this.leads_Copy.data[index].writer_id;
        Swal.fire('', 'Please Set a Writer Deadline.', 'error');
        return;
      }

      // Show loader
      this.leads.data[index].updatingAT = true;

      let url = AppSettings.API_ENDPOINT + "shared/update-order-writer";
      let data = { wid : lead.writer_id, oid : lead.id };
      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined" && resp.status == "OK") {

            let self = this;
            this.leads.data[index].writerUpdated = true;
            setTimeout(() => {
              self.leads.data[index].writerUpdated = false;

              // Remove Lead as its assigned
              self.leads.data.splice(index, 1);
            }, 1000);
          }
          // if(typeof resp != "undefined" && resp.status == "ERROR") {
          //   Swal.fire('', resp.message , 'error');
          // }

          // Hide loader
          this.leads.data[index].updatingAT = false;
      }).catch(err => {
          // Hide loader
          this.leads.data[index].updatingAT = false;
      });
    }

    updateWriterTime(lead, index) {
      if(!lead.writerDD_Col.writerDD || this.getCurrentDateTimeString(this.leads.data[index].writerDD_Col.writerDD) == this.leads_Copy.data[index].writerDD_Col.writerDD)
        return;

      // Show loader
      this.leads.data[index].updatingDD = true;

      let url = AppSettings.API_ENDPOINT + "shared/update-order-writer-due-date";
      let data = { writer_dd : this.getCurrentDateTimeString(lead.writerDD_Col.writerDD), id : lead.id };

      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined" && resp.status == "OK") {
            // Swal.fire('', resp.message , 'success');

            // Update Remaing Time
            this.leads.data[index].writerDD_Col.timeRemaining = resp.timeRemaining;
            this.leads.data[index].writerDD_Col.invert        = resp.invert;
            this.leads_Copy.data[index].writerDD_Col.writerDD = this.leads.data[index].writerDD_Col.writerDD;

            let self = this;
            this.leads.data[index].ddUpdated = true;
            setTimeout(() => {
              self.leads.data[index].ddUpdated = false;
            }, 1000);
          }

          // if(typeof resp != "undefined" && resp.status == "ERROR") {
          //   Swal.fire('', resp.message , 'error');
          // }

          // Hide loader
          this.leads.data[index].updatingDD = false;
      }).catch(err => {
            // Hide loader
            this.leads.data[index].updatingDD = false;
      });
    }

    getCurrentDateTimeString(dateString) {
      var date = new Date(dateString);

      var yr   = date.getFullYear();
      var mon  = date.getMonth() + 1;
      var mo   = mon < 10 ? '0' + mon : mon;
      var dayI = date.getDate();
      var day  = dayI < 10 ? '0' + dayI : dayI;

      var hours = date.getHours();
      var hr = hours < 10 ? '0' + hours : hours;

      var minutes = date.getMinutes();
      var min = (minutes < 10) ? '0' + minutes : minutes;

      var seconds = date.getSeconds();
      var sec = (seconds < 10) ? '0' + seconds : seconds;

      var newDateString = yr + '-' + mo  + '-' + day;
      var newTimeString = hr + ':' + min + ':' + sec;

      // 2021-07-01T19:00:00.000Z
      // 2021-07-01T00:00:00
      // 2021-07-01T00:00:00.000Z
      return newDateString + ' ' + newTimeString;
    }

    updateRegion(lead,index) {
      // Show loader
      this.leads.data[index].updatingReg = true;

      let url = AppSettings.API_ENDPOINT + "shared/update-order-region";
      let data = { region : lead.order_region, oid : lead.id };
      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined" && resp.status == "OK") {
            // Swal.fire('', resp.message , 'success');

            let self = this;
            this.leads.data[index].regUpdated = true;
            setTimeout(() => {
              self.leads.data[index].regUpdated = false;
            }, 1000);
          }

          // if(typeof resp != "undefined" && resp.status == "ERROR") {
          //   Swal.fire('', resp.message , 'error');
          // }

          // Hide loader
          this.leads.data[index].updatingReg = false;
      }).catch(err => {
            // Hide loader
            this.leads.data[index].updatingReg = false;
      });;
    }

    updateStatus(lead, index) {
      // Show Loader
      this.leads.data[index].updatingStatus = true;

      let url = AppSettings.API_ENDPOINT + "shared/update-order-status";
      let data = { id: lead.id, status: lead.status };
      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined") {

          }

          // Hide Loader
          this.leads.data[index].updatingStatus = false;
      }).catch(err => {
          // Hide Loader
          this.leads.data[index].updatingStatus = false;
      });
    }

    openUpdatePos(lead, index , column) {
      this.posIndex = index;

      this.posVal   = (column == "position") ? this.leads.data[this.posIndex].position:this.leads.data[this.posIndex].status;

      // Revert to actual until confirmed
      let self = this;
      setTimeout(() => {
        if(column == "position"){
          self.leads.data[self.posIndex].position = self.leads_Copy.data[self.posIndex].position;
        }else{
          self.leads.data[self.posIndex].status = self.leads_Copy.data[self.posIndex].status;
        }
        
      }, 50);

      $("#pos_modal_"+ column + index).modal("show");
      $(".modal-backdrop").click(function() {
        $("#pos_modal_"+column + index).modal("hide");
      });
    }

    updatePositionAndStatus(column) {
      // Show Loader
      
      if(column == "position"){
        this.leads.data[this.posIndex].updatingPosPosition = true;
      }else{
        this.leads.data[this.posIndex].updatingPosStatus = true;
      }
      

      // Hide modal
      $("#pos_modal_" + column + this.posIndex).modal("hide");

      // Set Vew Position Value
      if(column == "position"){
        this.leads.data[this.posIndex].position = this.posVal;
      }else{
        this.leads.data[this.posIndex].status = this.posVal;
      }
      

      let url = AppSettings.API_ENDPOINT + "shared/update-order-"+column;


      let data = null;

      if(column == "position"){
        data={ id: this.leads.data[this.posIndex].id, position: this.leads.data[this.posIndex].position }
      }else{
        data={ id: this.leads.data[this.posIndex].id, status: this.leads.data[this.posIndex].status }
      }
      console.log(data);
      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined" && resp.status == "OK") {
            let self = this;

            if(column == "position"){
              this.leads.data[this.posIndex].posUpdatedPosition = true;
            }else{
              
              this.leads.data[this.posIndex].posUpdatedStatus = true;
            }
            
            setTimeout(() => {
              if(column == "position"){
                this.leads.data[this.posIndex].posUpdatedPosition = false;
              }else{
                
                this.leads.data[this.posIndex].posUpdatedStatus = false;
              }
            }, 1500);
          }

          // Hide Loader
          if(column == "position"){
            this.leads.data[this.posIndex].updatingPosPosition = false;
          }else{
            this.leads.data[this.posIndex].updatingPosStatus = false;
          }
      }).catch(err => {
          // Hide Loader
          if(column == "position"){
            this.leads.data[this.posIndex].updatingPosPosition = false;
          }else{
            this.leads.data[this.posIndex].updatingPosStatus = false;
          }
      });
    }

    openModalVerify(lead, index, status){
      this.lead_Verify_index = index;
      this.lead_id_Verify    = lead.id;
      this.lead_status       = status;

      $("#veri_modal" + index).modal("show");
      $(".modal-backdrop").click(function() {
        $("#veri_modal" + index).modal("hide");
      });
    }

    verifyOrder() {
      // Show Loader
      this.leads.data[this.lead_Verify_index].updatingVeri = true;

      // Hide moda;
      $("#veri_modal" + this.lead_Verify_index).modal("hide");

      let url  = AppSettings.API_ENDPOINT + "shared/verify-order";
      let data = { oid: this.lead_id_Verify, status : this.lead_status};

      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined" && resp.status == "OK") {
            this.leads.data[this.lead_Verify_index].is_verified      = this.lead_status == '1' ?  true :  false;
            this.leads.data[this.lead_Verify_index].verified_by      = resp.order_verified_by;
            this.leads.data[this.lead_Verify_index].verified_by_date = resp.order_verified_date;
          }

          // Hide Loader
          this.leads.data[this.lead_Verify_index].updatingVeri = false;
      }).catch(err => {
            // Hide Loader
            this.leads.data[this.lead_Verify_index].updatingVeri = false;
      });
    }

    showNotes(lead, index) {
      // Show Loader
      this.leads.data[index].gettingNotes = true;

      this.addNoteId    = lead.id;
      this.addNoteIndex = index;
      let url = AppSettings.API_ENDPOINT + "shared/get-comments";
      let data = { o: lead.id, type : 'New-Order'};
      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined") {
            this.comments = resp;
          }

          $("#notesModal").modal("show");

          // Hide Loader
          this.leads.data[index].gettingNotes = false;
      }).catch(err => {
          // Hide Loader
          this.leads.data[index].gettingNotes = false;
      });
    }

    addNotes() {
      // Show Loader
      this.addingNote = true;

      let url = AppSettings.API_ENDPOINT + "shared/insert-note";
      let data = { id: this.addNoteId, note : this.notes, type : 'New-Order' };

      this.helperService.httpPostRequests(url,data).then(resp => {
          if(typeof resp != "undefined") {
              this.notes = "";
              this.leads.data[this.addNoteIndex].view_notes = true;
              $("#notesModal").modal("hide");
              Swal.fire('', resp.message , 'success');
          }

          // Hide Loader
          this.addingNote = false;
      }).catch(err => {
          // Hide Loader
          this.addingNote = false;
      });
    }

    updateAgent(lead, index) {
      console.log("lead", lead);

      let url = AppSettings.API_ENDPOINT + "admin/update-lead-agent";
      let data = { val: lead.agent_id, oid : lead.id };
      this.helperService.httpPostRequests(url,data).then(resp => {
        if(typeof resp != "undefined" && resp.status == "OK") {
          Swal.fire('', resp.message , 'success');
        }
        if(typeof resp != "undefined" && resp.status == "ERROR") {
          Swal.fire('', resp.message , 'error');
        }
      });
    }

    agentSearch(id, agentArr) {

      for (var i = 0; i < agentArr.length; i++) {
        if (agentArr[i].id === id) {
          return agentArr[i].name;
        }
      }
    }

    clearFilters(){
      this.searchParams = { order_Id_Email_Phone: '', position:'all', status: -1, agent_id: null, date_from: '', date_to:'', order_verified_by:'' };
      this.fullRangeDate = "";

      this.rerender();
    }

    setDeadlineTimer(time){
      if(typeof $ != "undefined"){
        // Set the date we're counting down to
        var countDownDate = new Date(time).getTime();

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if(days > 0){
          return days + 'd : ' + hours + 'hr : ' +  + minutes + 'Min' ;
        }
        else if(days == 0){
          return hours + 'hr : ' +  + minutes + 'Min' ;
        }
        else{
          return "-";
        }
      }
    }

}
